/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Redeem_InvalidInputs */

const en_us2_invite_redeem_invalid = /** @type {(inputs: Invite_Redeem_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That code does not look right. Check the letters and digits.`)
};

const pt_br2_invite_redeem_invalid = /** @type {(inputs: Invite_Redeem_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse código não parece certo. Confira as letras e os números.`)
};

const pt_pt2_invite_redeem_invalid = /** @type {(inputs: Invite_Redeem_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse código não parece certo. Confira as letras e os números.`)
};

/** @type {(inputs: Invite_Redeem_InvalidInputs) => LocalizedString} */
const es_419_invite_redeem_invalid = en_us2_invite_redeem_invalid;

/** @type {(inputs: Invite_Redeem_InvalidInputs) => LocalizedString} */
const fr_fr2_invite_redeem_invalid = en_us2_invite_redeem_invalid;

/** @type {(inputs: Invite_Redeem_InvalidInputs) => LocalizedString} */
const de_de2_invite_redeem_invalid = en_us2_invite_redeem_invalid;

/** @type {(inputs: Invite_Redeem_InvalidInputs) => LocalizedString} */
const it_it2_invite_redeem_invalid = en_us2_invite_redeem_invalid;

/**
* | output |
* | --- |
* | "That code does not look right. Check the letters and digits." |
*
* @param {Invite_Redeem_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_redeem_invalid = /** @type {((inputs?: Invite_Redeem_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Redeem_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_redeem_invalid(inputs)
	if (locale === "es-419") return es_419_invite_redeem_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_redeem_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_redeem_invalid(inputs)
	if (locale === "de-DE") return de_de2_invite_redeem_invalid(inputs)
	if (locale === "it-IT") return it_it2_invite_redeem_invalid(inputs)
	return en_us2_invite_redeem_invalid(inputs)
});
export { invite_redeem_invalid as "invite.redeem_invalid" }